<template>
<div class="cart">
  <van-nav-bar title="兑换袋" fixed left-arrow @click-left="goBack" @click-right="onClickRight" style="z-index: 100">
       <span  slot="right" v-if="!redact">编辑</span>
        <span slot="right" v-if="redact">完成</span>
  </van-nav-bar>
  <div class="van-content">
    <div class="nodata text-cent" v-if="finished && datas == ''">
      <P class="imgbox">
        <img src="/static/images/nodataimg3.png"/>
      </P>
      <p class="text">兑换袋空空哒~</p>
    </div>
    <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
      <van-checkbox-group v-model="onDatas">
        <van-checkbox label-disabled v-for="(items, index) in datas" :name="items" :key="items.id">
          <van-cell-swipe :right-width="60" :left-width="0">
            <van-cell-group>
              <van-card class="goodsonelist">
                <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/goodslist/goods',query:{id:items.product_id}}">
                  <img onerror="src='/static/errorimg1.png'" :src="items.product_img">
                </router-link>
                <div slot="title" class="ellipseal van-card-title">
                  <p class="tagbox">
                    <van-tag class="theme-bg theme-bd" v-if="items.is_new == 1">新品</van-tag>
                    <van-tag class="theme-bg theme-bd" v-if="items.is_hot == 1">热销</van-tag>
                    <van-tag class="theme-bg theme-bd" v-if="items.is_rob == 1">限时</van-tag>
                  </p>
                  <div class="ellipseal">
                    <van-tag plain class="theme-col theme-bd jd" v-if="items.dummy == 3">京东</van-tag>{{ items.product_name }}
                  </div>
                </div>
                <div slot="desc" class="van-card-desc theme-col">{{ items.points_price }} </div>
                <div slot="footer"><van-stepper v-model="items.nums" /></div>
              </van-card>
            </van-cell-group>
            <span slot="right"><button class="clearbtn theme-bd theme-bg" @click="removeGoods(items.id,index)">删除</button></span>
          </van-cell-swipe>
        </van-checkbox>
      </van-checkbox-group>
      <div v-if="!loading && finished && datas != ''" class="nomore"><span>已经到底了</span></div>
    </van-list>
  </div>
  <div v-if="control" class="van-submit-bar">
    <div class="van-submit-bar__bar">
      <van-checkbox v-model="checkedall" style="margin-left: 15px">全选</van-checkbox>
      <div class="van-submit-bar__price">
        <span>合计：</span><span class="van-submit-bar__price-integer theme-col">{{ points_prices }}{{ configData.integral_name }} <span v-if="money_price != 0">+¥{{ money_price.toFixed(2) }}元</span></span>
      </div>
      <button class="van-button theme-bg van-button--normal" @click="buyBtn()">
        <span class="van-button__text" v-if="!redact">提交订单</span>
        <span class="van-button__text" v-if="redact">删除</span>
      </button>
    </div>
  </div>
  <!--底部导航-->
  <footer-nav></footer-nav>
</div>
</template>

<script>
  import FooterNav from '@/components/footernav'
  export default {
    name: "cart",
    components: {
      FooterNav
    },
    props:['configData','userConfig'],
    data () {
      return {
        checkedall:false,
        datas:[],
        onDatas:[],
        page:0,
        finished:false,
        loading:false,
        redact:false,//编辑开关
        control:false
      }
    },
    watch: {
      checkedall:function () {
        var _this = this
        if(this.checkedall){
          _this.onDatas = []
          $.each(this.datas,function (index,items) {
            _this.onDatas.push(items)
          })
        }
        if(!this.checkedall&&this.onDatas.length == this.datas.length){
          _this.onDatas = []
        }
      },
      datas: function () {
        this.onDatas.length == this.datas.length?this.checkedall = true:this.checkedall = false
      },
      onDatas: function () {
        this.onDatas.length == this.datas.length?this.checkedall = true:this.checkedall = false
      }
    },
    computed: {
      //积分价格
      points_prices:function () {
        var _this = this
        var total = 0
        $.each(_this.onDatas,function (index,items) {
          total += items.nums*items.points_prices
        })
        return total
      },
      //现金价格
      money_price:function () {
        var _this = this
        var total = 0
        $.each(_this.onDatas,function (index,items) {
          total += items.nums*items.money_price
        })
        return total
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight: function () {
        this.redact = !this.redact
      },
      buyBtn: function () {
        var _this = this
        var isUser = localStorage.getItem("BLHuser")
        if(this.redact && this.onDatas.length != 0){
          var onDatasId = []
          $.each(this.onDatas,function (index,items) {
            // onDatasId[items.product_id] = items.nums
            onDatasId.push(items.id)
          })
          var strOnDatasId = JSON.stringify(onDatasId)/*.replace(/\"/g, "")*//*.replace(/^\{/gi, '').replace(/\}$/gi, '')*/
          this.$api.post('WebApi/Member/Cart/delCart', {token:isUser,id:onDatasId}, res => {
            if(res.data.errCode == '0000') {
              this.$toast(res.data.desc)
              $.each(this.onDatas,function (index,items) {
                _this.datas.splice($.inArray(items,_this.datas), 1)
              })
              this.onDatas = []
              this.$api.post('WebApi/Member/Cart/index', {token: isUser, p: this.page}, res => {
                if (res.data.errCode == '0000') {
                  if (res.data.data.length != 0) {
                    $.each(res.data.data, function (items, index) {
                      if (!_this.datas[items]) {
                        _this.datas.push(items);
                      }
                    })
                  }
                }
              })
            }else if(res.data.errCode == '1002'){
              this.$dialog.confirm({
                title:'提示',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({path:'/login'})
              }).catch(() => {
                // on cancel
              });
            }else{
              this.$toast(res.data.desc)
            }
          })
        }
        else if(!this.redact && this.onDatas.length != 0){
          var onDatasId = {}
          $.each(this.onDatas,function (index,items) {
            onDatasId[items.product_id] = items.nums
          })
          var strOnDatasId = JSON.stringify(onDatasId)/*.replace(/\"/g, "")*//*.replace(/^\{/gi, '').replace(/\}$/gi, '')*/
          this.$api.post('WebApi/JifenOrder/CreatOrder/index', {token:isUser,goods:strOnDatasId}, res => {
            if(res.data.errCode == '0000'){
              this.$router.push({path:'/affirmOrder'})
            }else if(res.data.errCode == '1002'){
              this.$dialog.confirm({
                title:'提示',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({path:'/login'})
              }).catch(() => {
                // on cancel
              });
            }else{
              this.$toast(res.data.desc)
            }
          })
        }
        else {
          this.$toast("请选择商品")
        }
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        setTimeout(() => {
          this.page++
          this.$api.post('WebApi/Member/Cart/index', {token:isUser,p:this.page}, res => {
            if(res.data.errCode == '0000'){

              _this.finished = true;
              _this.loading = false;

              if(res.data.data.length==0){
                _this.finished = true;
                _this.loading = false;
              }else{
                _this.control=true;
                for (let i = 0; i < res.data.data.length; i++) {
                  _this.datas.push(res.data.data[i]);
                }
                _this.loading = false;
              }
            }else{
              this.$toast.alert(res.data.desc);
              _this.loading = false;
            }
          })
        },50)
      },
      removeGoods:function (id,index) {
        var _this = this
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Cart/delCart', {token: isUser, id: id}, res => {
          if (res.data.errCode == '0000') {
            this.$toast(res.data.desc,123)
            if ($.inArray(this.datas[index], this.onDatas) != -1) {
              this.onDatas.splice($.inArray(this.datas[index], this.onDatas), 1)
            }
            this.datas.splice(index, 1)
            this.$api.post('WebApi/Member/Cart/index', {token: isUser, p: this.page}, res => {
              if (res.data.errCode == '0000') {
                if (res.data.data.length != 0) {
                  $.each(res.data.data, function (items, index) {
                    if (!_this.datas[items]) {
                      _this.datas.push(items);
                    }
                  })
                }
              }
            })
          } else if (res.data.errCode == '1002') {
            this.$dialog.confirm({
              title: '提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path: '/login'})
            }).catch(() => {
              // on cancel
            });
          } else {
            this.$toast(res.data.desc)
          }
        })
      }
    },
    mounted () {

    },
  }
</script>
<style lang="less">
  .cart{
    .footNav{
      z-index: 99;
    }
    .van-submit-bar{
      bottom: 56px;
      border-bottom: 1px solid #f2f2f2;
    }
    .van-cell-swipe{
      padding-left: 35px;
    }
    .van-cell-group{
      margin-bottom: 0  ;
    }
    .clearbtn{
      width: 65px;
      height: 100%;
    }
    .goodsonelist.van-card, .goodsonelist{
      margin: 0;
    }
    .goodsonelist{
      .van-card__footer{
        bottom: 7px;
        .van-stepper{
          .van-stepper__minus, .van-stepper__plus {
            width: 25px;
            height: 25px;
          }
          .van-stepper__input {
            width: 25px;
            height: 21px;
          }
        }
      }
    }


    .van-content{
      padding-bottom: 107px;
      .van-checkbox__label{
        width: 100%;
        margin-left: 0;
        background: #fff;
      }
      .van-checkbox{
        margin: 10px 0;
        .van-checkbox__icon{
          position: absolute;
          margin-top: 40px;
          z-index: 99;
          left: 15px;
       }
      }
      .van-cell-swipe__wrapper{
        position: relative;
        z-index: 99;
      }
    }
  }
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/user/cart/cart.vue